export default __webpack_public_path__ + "static/media/field.c0059460.png";